<script>
	import Multiselect from "vue-multiselect";
	export default{
		components: { Multiselect },
		data(){
			return{
				id: '',
				options: [
					{id: 1, name: 'text'},
					{id: 2, name: 'text2'}
				],
				search: '',
				currentPage: 1,
				order: 'desc',
      			sortby: 'id',
      			storageurl: '/image/',
      			limit: 0,
				limits: [
		        {value: 25, text: "25"},
		        {value: 50, text: "50"},
		        {value: 100, text: "100"},
		    	],
				response_error: []
			}
		},
		props: {
			isDisabled: {
				type: Boolean,
				default: () => false,
				},
			marketplace_categories: {
				type: String,
				default: () => 'company'
			},
			categories_data: {
				type: Array,
				default: () => null
			}
		},
		created(){
			if(this.categories_data == null){
				
			}
			this.id = this.$attrs.id;
		},
		mounted(){
			this.id = this.$attrs.id;
		},
		methods:{
			updateDepartment: function(selectedOption, id){
				this.$emit('attribute-value-selected', selectedOption);
			},
			customLabel ({ title, desc }) {
		      return `${title} – ${desc}`
		    }
		}
	}
</script>
<template>
	<div>
	<multiselect v-model="id" track-by="name" label="name" :options="categories_data" @select="updateDepartment" :option-height="104" :disabled="isDisabled" >
                     <!--<template slot="singleLabel" slot-scope="{ option }">{{ option.name }} - {{ option.jobtitle }}</template>-->
                     <template slot="singleLabel" slot-scope="{ option }"><div class="d-flex w-100 h-100"><div class="avatar-sm mr-4 my-auto">
                        <img class="avatar-title rounded-circle bg-light" v-if="option.image" :src="storageurl+option.image">
                        <img class="avatar-title rounded-circle bg-light" v-else src="/images/product-placeholder.png">
                      </div>
      <div class="option__desc d-flex flex-row w-75"><span class="option__title ml-2 my-auto w-100">{{ option.name }}<br></span>
      </div>
  		</div></template>
    <template slot="option" slot-scope="{ option }">
    	<div class="d-flex"><div class="avatar-sm mr-4">
                        <img class="avatar-title rounded-circle bg-light" v-if="option.image" :src="storageurl+option.image">
                        <img class="avatar-title rounded-circle bg-light" v-else src="/images/product-placeholder.png">
                      </div>
      <div class="option__desc d-flex flex-row w-50"><span class="option__title ml-2 my-auto w-100">{{ option.name }}<br></span>
      </div>
  		</div>
    </template>
                  </multiselect>
                 
   </div>
</template>